<template>
  <el-dialog
    title="新增"
    :visible.sync="visible"
    width="400px"
    @close="handleClose"
  >
    <el-row>
      <el-col :span="9">当前修改sim卡类型</el-col>
      <el-col :span="15">
        <el-input 
          size="small"
          v-model="simType"
          :disabled="true"
          type="text"
        />
      </el-col>
      <el-col :span="9">续费价格</el-col>
      <el-col :span="15">
        <el-input 
          size="small"
          v-model.number="params.price"
          type="number"
        />
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="handleSave">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props:{
    simType:{
      type:String,
      default:'30M'
    }
  },
  data(){
    return {
      visible:false,
      params:{
        price:null,
      }
    }
  },
  created(){
    console.log(this.simType);
  },
  methods:{
    async handleSave(){
      try{
        if(!this.params.price)throw{msg:'请输入续费价格'};
        const { code,msg } = await this.$API.updateRenewalManagement({...this.params,simType:parseInt(this.simType)});
        if(code == 0){
          this.$message({
            type:'success',
            message:'设置成功'
          });
          this.visible = false;
          this.$emit('getData');
        }else{
          throw{msg:msg}
        }
      }catch({msg}){
        this.$message({
          type:'warning',
          message:msg
        })
      }
    },
    handleClose(){
      this.params = {
        price:null,
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.el-col{
  margin-bottom: 10px;
  line-height: 36px;
}
/deep/ .el-dialog__body{
  padding: 10px 20px;
}
/deep/ .el-dialog .el-dialog__footer{
  padding: 10px;
}
</style>